export default __webpack_public_path__ + "static/media/card-mastercard.d68df551.svg";